/* eslint-disable react/prop-types */
import { createContext, useState, useEffect, useCallback } from "react";
import { getFromLocalStorage, removeFromLocalStorage } from "../utils";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

// Define unprotected routes
const unprotectedRoutes = [
  "/",
  "/shopnow",
  "/auth/login/buyer",
  "/auth/register/buyer",
  "/auth/login/pharm",
  "/auth/register/pharm",
  "/auth/forgotpassword",
  "/auth/forgotpassword/pharm",
  "/auth/select-user-type",
];

// Check if the route is unprotected
const isUnprotectedRoute = (path) => {
  return unprotectedRoutes.some((route) => path.startsWith(route));
};

export const AuthContext = createContext(null);

const AuthContextProvider = ({ children }) => {
  const data = getFromLocalStorage("userData");
  const [userData, setUserData] = useState(data || null);
  const navigate = useNavigate();
  const location = useLocation();

  const logOut = useCallback(() => {
    setUserData(null);
    removeFromLocalStorage("userData");
    toast.info("You have been logged out.", { autoClose: 3000 });
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const checkTokenExpiration = () => {
      console.log("Current Path:", location.pathname);
      console.log(
        "Is Unprotected Route:",
        isUnprotectedRoute(location.pathname)
      );

      if (userData) {
        const { expiration } = userData;
        const isExpired = new Date() > new Date(expiration);

        if (isExpired) {
          toast.info(
            "Your session has expired and you have been logged out. Kindly log in again.",
            { autoClose: 3000 }
          );
          logOut();
        }
      } else if (!isUnprotectedRoute(location.pathname)) {
        navigate("/auth/select-user-type");
      }
    };

    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 1000 * 60);
    return () => clearInterval(interval);
  }, [userData, logOut, location.pathname, navigate]);

  return (
    <AuthContext.Provider value={{ userData, setUserData, logOut }}>
      {children}
      <ToastContainer />
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
